import OrganizationDetailBadges from '@/screens/OrganizationDetailBadges';

export default function PrivateTabsOrganizationMainBadgesRoute() {
  return <OrganizationDetailBadges />;
}
